<template lang="pug">
.queue-card
  .bg
    img(src="~assets/queue-forest.png")
  .content
    .title 飞跃蚂蚁森林
    queue-info(:exhibitId="exhibitId")
    //.subtitle 还有5位
    //template(v-if="exp.queueCode")
    //  .queue-code {{exp.queueCode}}
    //template(v-else-if="exp.access === 1")
    //  .queue-btn(@click="onQueue") 排号
    //template(v-else)
    //  member-ticket-money(:grade="grade" :price="ticket? ticket.ticketMoney: ''")
    .warning(@click="onWarning")
      img(src="~assets/warning.png")
      span 风险提示

</template>
<script>
import { mapState, mapMutations } from 'vuex'
import MemberTicketMoney from '@/components/wedgits/MemberTicketMoney'
import QueueInfo from '@/components/home/QueueInfo'
export default {
  name: 'QueueCard',
  components: { QueueInfo, MemberTicketMoney },
  props: {
    exhibitId: {},
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['user']),
  },
  methods: {
    ...mapMutations('app', ['setRouterBack']),
    onWarning() {
      this.setRouterBack('/')
      this.$router.replace(`/home/warning`)
    },
  },
  mounted() {
    //console.log('tickets!!!!!!!!!!!', this.user.tickets)
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.queue-card
  width: pxToRem(750)
  height: pxToRem(374)
  position: relative
  .bg
    +full
    img
      width: 100%
      height: 100%
      object-fit: contain
      display: block
  .content
    position: absolute
    padding: pxToRem(60)
    .title
      font-size: pxToRem(36)
      line-height: pxToRem(38)
      color: white
      text-shadow: 0 2px 1.7px rgba(11, 4, 7, 0.2)
    .queue-btn
      margin-top: pxToRem(30)
      margin-bottom: pxToRem(10)
      width: pxToRem(168)
      height: pxToRem(58)
      border-radius: pxToRem(29)
      background: white
      color: #1664FF
      font-size: pxToRem(30)
      line-height: pxToRem(58)
      text-align: center
    .warning
      display: flex
      align-items: center
      flex-direction: row
      position: absolute
      img
        width: pxToRem(31)
        height: pxToRem(31)
        object-fit: contain
        margin-right: pxToRem(10)
        margin-bottom: pxToRem(-4)
      span
        font-size: pxToRem(24)
        color: white
        border-bottom: white 1px solid
</style>
